import { GO_TO_LOGIN } from './login.constants';

export const goToLoginPage = () => ({
    type: GO_TO_LOGIN
});
